const baseUrl = '/api/customer/user/subscriber'

export default {
    checkSubscribers: (potentialSubscriberIds) => {
        return axios.post(`${baseUrl}/check`, {
            userIds: potentialSubscriberIds,
        })
    },
}
